import * as THREE from './vendor/three.min.js';

export default {
  renderer: undefined,
  camera: undefined,
  scene: undefined,
  planeUniforms: undefined,

  init: function(options) {
    this.scene = new THREE.Scene();

    var divider = 0.7;
    var W = 1588 * divider; // seed
    var H = 1379 * divider; // seed

    var squareSize = 19.0;
    var rows = Math.ceil(H / squareSize);
    var columns = Math.ceil(W / squareSize);

    this.renderer = new THREE.WebGLRenderer({ alpha: true });
    this.renderer.setPixelRatio(window.devicePixelRatio ? window.devicePixelRatio : 1);
    this.renderer.setSize(window.innerWidth, window.innerHeight);

    this.camera = new THREE.PerspectiveCamera(45, W / H, 0.1, 1000);
    this.camera.position.set(0, 110 * divider, 450 * divider);
    this.camera.lookAt( this.scene.position );
    // adapt the camera dynamically
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();

    // create plane geometry
    this.planeUniforms = {
      time: {
        type: 'f',
        value: 0
      },
      resolution: {
        type: 'v2',
        value: new THREE.Vector2(W, H)
      },
      baseColor: {
        type: 'c',
        value: new THREE.Color(0x004b65)
      },
      gradientColor: {
        type: 'c',
        value: new THREE.Color(0xba5dd2)
      }
    };

    var vertexShader = 'varying vec3 vColor; varying vec3 vPos; uniform float time; uniform vec3 baseColor; uniform vec2 resolution; uniform vec3 gradientColor; vec2 hash( vec2 p ) { p = vec2( dot( p, vec2( 127.1,311.7 ) ), dot( p, vec2( 269.5, 183.3 ) ) ); return -1.0 + 2.0*fract(sin(p)*19758.5453123); } float noise( in vec2 p ) { vec2 n_i = floor( p ); vec2 n_f = fract( p ); vec2 n_u = n_f*n_f*(3.0-2.0*n_f); return 6.0 * mix( mix( dot( hash( n_i + vec2(0.0,0.0) ), n_f - vec2(0.0,0.0) ), dot( hash( n_i + vec2(1.0,0.0) ), n_f - vec2(1.0,0.0) ), n_u.x), mix( dot( hash( n_i + vec2(0.0,1.0) ), n_f - vec2(0.0,1.0) ), dot( hash( n_i + vec2(1.0,1.0) ), n_f - vec2(1.0,1.0) ), n_u.x), n_u.y); } vec3 applyNoise(vec2 p, float coef) { float n = cos( noise(p.xy*.1)+time ) + cos( noise(p.xy*.01)+time/5.0 )*4.0; return vec3(p, n*coef); } void main() { vec3 pos = applyNoise(position.xy, 2.1); vPos = (modelViewMatrix * vec4(pos, 1.0)).xyz; gl_Position = projectionMatrix * modelViewMatrix * vec4( pos, 1.0 ); vec3 black = vec3(0.0, 0.0, 0.0); vec3 processedGColor = vec3(mix(baseColor, gradientColor, (gl_Position.z / (resolution.y / 1.35)))); vColor = vec3(mix(processedGColor, black, (gl_Position.z / (resolution.y / 1.0)))); }';
    var fragmentShader =  '#extension GL_OES_standard_derivatives : enable \n varying vec3 vColor; varying vec3 vPos; const vec3 lightPosEc = vec3( 1.0, 1.0, .5 ); void main() { vec3 X = dFdx( vPos ); vec3 Y = dFdy( vPos ); vec3 normal = normalize( cross( X, Y ) ); vec3 lightDirection = normalize( lightPosEc - vPos ); float light = max( 0.0, dot( lightDirection, normal ) ); gl_FragColor = vec4( vColor * light, 1.0 );}';
    var planeMaterial = new THREE.ShaderMaterial( {
      uniforms: this.planeUniforms,
      vertexShader: vertexShader,
      fragmentShader: fragmentShader
    } );
    var planeGeometry = new THREE.PlaneGeometry(W, H, columns, rows);
    var plane = new THREE.Mesh(planeGeometry, planeMaterial);
    plane.rotation.x = -Math.PI * 0.5;
    plane.position.set(0, 0, 0);
    this.scene.add(plane);

    this.renderer.render( this.scene, this.camera );
    document.getElementById('webgl-plane').appendChild(this.renderer.domElement);

    this.drawFrame();

    if (options.resize === true) {
      window.addEventListener('resize', function() {
        this.resize();
      }.bind(this));
    }
  },

  resize: function() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(window.innerWidth, window.innerHeight);
  },

  drawFrame: function(ts) {
    this.planeUniforms.time.value = ts / 1000;
    this.renderer.render(this.scene, this.camera);
    window.requestAnimationFrame(this.drawFrame.bind(this));
  }
};
